
import {
  computed, defineComponent, Ref, ref,
} from 'vue';
import { NETWORK_CONTACT_TYPES } from '@/types/enums';
import { useSpacesStore } from '../store/spacesStore';
import SpacesUser from './SpacesUser.vue';
import SpacesUserTransition from './SpacesUserTransition.vue';
import AppItemWrapper from '@/components/AppItemWrapper.vue';
import AppSkeletonContact from '@/components/skeletons/AppSkeletonContact.vue';

export default defineComponent({
  props: {
    skeleton: { type: Boolean, default: false },
  },
  components: {
    SpacesUser,
    SpacesUserTransition,
    AppItemWrapper,
    AppSkeletonContact,
  },
  setup() {
    const spacesStore = useSpacesStore();
    const showAll: Ref<boolean> = ref(false);

    const users = computed(() => {
      if (!showAll.value) {
        return spacesStore.filteredSuggestions.length <= 3 ? spacesStore.filteredSuggestions : spacesStore.filteredSuggestions.slice(0, 3);
      }
      return spacesStore.filteredSuggestions;
    });

    return {
      spacesStore, users, NETWORK_CONTACT_TYPES, showAll,
    };
  },
});
